import React from "react"
import { Box } from "@mui/material"

import { AppButtonIcon, AppButtonLoading } from "@components"
import { useUserSettingsWebSupplierGroup } from "../../@hooks"


export default function actionsColumn() {
	return {
		name: "id", label: "Actions",
		options: {
			filter: false,
			customBodyRowRenderLite: (_, rowData) => <ActionsCell rowData={rowData} />,
		}
	}
}

function ActionsCell({ rowData }) {
	const { isLoading, isClicked, handleSetFormData, handleDeleteRow } = useUserSettingsWebSupplierGroup(rowData)

	if (isLoading) return <AppButtonLoading />

	return <Box className={isClicked ? "clicked-details" : ""} sx={{ display: 'flex', justifyContent: 'center' }}>
		<AppButtonIcon icon="pen" tooltip="Edit" onClick={handleSetFormData} />
		<AppButtonIcon icon="trash-can" tooltip="Delete" onClick={handleDeleteRow} />
	</Box>
}